// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3xJRG","footer":"ModalUpdate_footer__1B-Gb"};